export default "__VITE_ASSET__DC4eUnt3__"